import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async getProcessos ({ commit }, { dados }) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `subprocesso/filtro`
    })
    return data
  },
  async iniciaAnalise ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `subprocesso/${dados.id}/iniciaAnalise`
    })
    return data
  },
  async getSubProcesso ({ commit }, dados) {
    const data = await axios({
      method: 'GET',
      url: `subprocesso/${dados.id}/processo`
    })
    return data
  },
  async vincularVistoriadorCredenciado ({ commit }, dados) {
    const data = await axios({
      method: 'POST',
      url: `subprocesso/vincular/vistoriador/credenciado`,
      data: dados
    })
    return data
  },
  async atualizaDadosSubProcesso ({ commit }, id) {
    const data = await axios({
      method: 'PUT',
      url: `subprocesso/lipaPlanilha/${id}`,
      data: {}
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/subProcesso.js